import styled from "styled-components";
import TextHome1 from "./home1/TextHome1";
import TextHome2 from "./home2/TextHome2";
import TextHome3 from "./home3/TextHome3";
import home1 from "./home1/home1.PNG";
import home2 from "./home2/home2.PNG";
import home3 from "./home3/home3.PNG";
import { TipMouseOutEvent, TipMouseOverEvent } from "../../../Tooltip/Tooltip";


function CarrouselItem(props) {

    if (props.itemUrl === "home1"){
        return(
        <CarrouselBox
        onMouseOver={(event) => TipMouseOverEvent(event, "Aventuras como você <br> nunca viu!", "#2196F3")}
        onMouseLeave={() => TipMouseOutEvent()}>
            <CarrouselImg carrouselitemimg={home1}/>
            <TextHome1 />
        </CarrouselBox>
        );
    } else
    if (props.itemUrl === "home2"){
        return(
        <CarrouselBox
        onMouseOver={(event) => TipMouseOverEvent(event, "Diversão sem igual!","rgb(49, 145, 34)")}
        onMouseLeave={() => TipMouseOutEvent()}>
            <CarrouselImg carrouselitemimg={home2}/>
            <TextHome2 />
        </CarrouselBox>
        );
    } else
    if (props.itemUrl === "home3"){
        return(
        <CarrouselBox onMouseOver={(event) => TipMouseOverEvent(event, "Transparencia e confiança","rgb(189, 70, 70)")} onMouseLeave={() => TipMouseOutEvent()}>
            <CarrouselImg carrouselitemimg={home3}/>
            <TextHome3 />
        </CarrouselBox>
        );
    }
};



const CarrouselBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 30%;
    align-items: center;
    padding: 10px 10px;
    transition: .3s ease-in-out;
    //border: solid 2px black;
    z-index: 2;
    text-align: justify;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    @media (max-width: 1000px) {
    width: 90vw;
    margin-bottom: 30px;
    text-align: justify;
    }

    &:hover {
    filter: saturate(150%);
    scale: 1.1;
    }
`;


const CarrouselImg = styled.div`
    background-image: url("${props => props.carrouselitemimg}");
    background-size: cover;
    width: 260px;
    height: 346px;
`;

export default CarrouselItem

